import { getApiBaseUrl } from './config';

async function parseJson(response) {
  let payload = null;
  try {
    payload = await response.json();
  } catch {
    payload = null;
  }
  return payload;
}

/**
 * Guest search: GET /api/public/advisers?search=
 */
export async function searchAdvisers(query, { limit = 24, offset = 0 } = {}) {
  const base = getApiBaseUrl();
  const params = new URLSearchParams({
    search: String(query || '').trim(),
    limit: String(limit),
    offset: String(offset),
  });
  const url = `${base}/api/public/advisers?${params.toString()}`;

  const response = await fetch(url, {
    headers: { Accept: 'application/json' },
  });
  const payload = await parseJson(response);

  if (!response.ok) {
    throw new Error(payload?.message || `Error searching advisers (${response.status})`);
  }

  return {
    items: Array.isArray(payload?.items) ? payload.items : [],
    total: Number(payload?.total) || 0,
    hasMore: Boolean(payload?.hasMore),
    nextOffset: Number(payload?.nextOffset) || 0,
  };
}

/**
 * Guest profile: GET /api/public/advisers/:publicId
 */
export async function fetchAdviser(publicId) {
  const base = getApiBaseUrl();
  const id = encodeURIComponent(String(publicId || '').trim());
  const url = `${base}/api/public/advisers/${id}`;

  const response = await fetch(url, {
    headers: { Accept: 'application/json' },
  });
  const payload = await parseJson(response);

  if (!response.ok) {
    throw new Error(payload?.message || `Error loading adviser (${response.status})`);
  }

  return payload;
}
